import { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from '../../_services/authService';
import axios from "axios";
import { config } from "../../App";
import "./Header.scss";

const UserProfilePopup = ({ show, handleClose, user }) => {
  const userName = sessionStorage.getItem("username");
  const empId = sessionStorage.getItem("EmployeeID");
  const { logout, token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [profileData, setProfileData] = useState({});

  const getProfileData = async () => {
    try {
      const response = await axios.get(
        `${config.endpoint}/Home/getprofile?employeeId=${empId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      // console.log("profileData", response)
      if (response.data.status === true) {
        setProfileData(response.data.Data);
      } else {
        setProfileData({});
      }

    } catch (error) {
      console.error("failed:", error);
    }
  }

  const handleLogout = async (event) => {
    event.preventDefault();

    try {
      const payload = {
        Username: empId,
        AppName: "ess"
      };

      await axios.post(
        `${config.endpoint}/auth/logout`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      sessionStorage.clear();
      logout();
      navigate(`/login`, { replace: true });

    } catch (error) {
      console.error("Logout failed:", error);
      sessionStorage.clear();
      logout();
      navigate(`/login`, { replace: true });
    }
  };

  useEffect(() => {
    getProfileData();
  }, [])


  return (
    <>
      {show && <div className="profile-overlay" onClick={handleClose}></div>}

      <div className={`profile-popup ${show ? "show" : ""}`}>
        <div className="profile-header">
          <div className="profile-user">
            <img src={`/images/blank-profile.png`} alt="" />

            <div>
              <div className="name">{profileData.FullName}</div>
              <div className="email">{profileData.OfficialMailId}</div>
              <div className="phone">{profileData.MobileNumber}</div>
              {/* <a className="signout" onClick={handleLogout}>
                Sign Out
              </a> */}
            </div>
          </div>

          <span className="close-btn" onClick={handleClose}>✕</span>
        </div>

        <div className="about">
          <div className="details">
            <h6 class="fw-bold">About</h6>
            <p>Employee ID: <span class="d-block">{profileData.EmployeeID}</span></p>
            <p>Designation:<span class="d-block">{profileData.Designation}</span></p>
            <p>Department:<span class="d-block">{profileData.Department}</span></p>
            <p>DOJ:<span class="d-block">{profileData.DOJ}</span></p>
            {profileData?.Shift && (<p>Shift:<span class="d-block">{profileData.Shift}</span></p>)}
            <p>Location:<span class="d-block">{profileData.Location}</span></p>
          </div>
        </div>
        <div className="p-3 pt-0">
          <div className="d-flex justify-content-between px-4 py-3 mb-2 bg-white">
            <Link className="changepass" to={`/change-password`} onClick={handleClose} >
              Change Password
            </Link>
            <a className="signout" onClick={handleLogout}>
              Sign Out
            </a>
          </div>
        </div>

      </div>
    </>
  );
};

export default UserProfilePopup;